import React, { useContext, useState } from 'react'
import { Button, Form, Input, message, Radio } from 'antd';
import { CardContext } from '../../store/CardContext';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { sendFormDatas } from '../../../api/UserRequest';
const { TextArea } = Input;

function Contact() {
    const [activeTab, setActiveTab] = useState('tab1')
    const showTab = (tabId) => {
        // console.log(tabId);
        setActiveTab(tabId)
    }
    const [cardData] = useContext(CardContext)
    // console.log(cardData, 'cardData');
    const {
        logo,
        contactForm,
        informations,
        colors,
        _id,
    } = cardData

    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
    // const [phone, setPhone] = useState('');
    // const [shared, setShared] = useState(false);

    const txtColor = colors?.txtColor ? colors?.txtColor : "black"
    const btnColor = colors?.btnColor ? colors?.btnColor : "black"
    const btnTxtColor = colors?.btnTxtColor ? colors?.btnTxtColor : "white"



    const [messageApi, contextHolder] = message.useMessage();
    const success = () => {
        messageApi.open({
            type: 'success',
            content: contactForm?.successMessage ? contactForm?.successMessage : "Thank you for Your Response.",
        });
    };

    const error = (msg) => {
        messageApi.open({
            type: 'error',
            content: msg,
        });
    };

    const resetForm = () => {
        form.resetFields();
    };

    const onFinish = async (values) => {
        // console.log('Success:', values);

        try {
            setLoader(true);
            const { data } = await sendFormDatas(_id, values)
            // console.log(data);
            if (data.success) {
                // setShared(true);
                resetForm()
                setLoader(false);
                success()
            }

        } catch (err) {
            setLoader(false);
            error(err.message ? err.message : "Some thing went Wrong, Please thry after soem time!!")
        }
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    return (
        <div>
            <div className="contact " style={{ color: txtColor }} >
                <div className="live_header w-full flex mx-auto py-5 justify-between items-center flex-shrink-0  shadow-md ">
                    <div className="live_header_logo flex justify-between items-center gap-2.5 mx-3">
                        <img className='w-10 h-10' src={logo} />
                        <p
                            className="text-center  text-base font-semibold"
                            id="l-update"
                        >
                            Feedback
                        </p>
                    </div>

                </div>
                <div className="about_details px-4">
                    <div className="flex items-center justify-center mb-5">
                        <div className="tab-container flex justify-around border-2  rounded-full w-full mx-2 mt-5">
                            <div
                                className={`tab ${activeTab === 'tab1' && 'bg-sky-500'} text-center p-2 w-full rounded-l-full`}
                                id="tab1button"
                                style={{
                                    background: activeTab === 'tab1' && btnColor,
                                    color: activeTab === 'tab1' && btnTxtColor
                                }}
                                onClick={(e) => showTab('tab1')}
                            >
                                {contactForm?.buttonName}
                            </div>
                            <div
                                className={`tabone ${activeTab === 'tab2' && 'bg-sky-500'} text-center p-2 w-full rounded-r-full`}
                                id="tab2button"
                                style={{
                                    background: activeTab === 'tab2' && btnColor,
                                    color: activeTab === 'tab2' && btnTxtColor
                                }}
                                onClick={(e) => showTab('tab2')}
                            >
                                {informations?.buttonName}
                            </div>
                        </div>
                    </div>
                    {activeTab === "tab1" &&
                        <>
                            {contactForm?.tittle &&
                                <p class="font-semibold text-base  text-center my-4" id="c-LocalAddress">
                                    {contactForm?.tittle}
                                </p>
                            }
                            <Form
                                name="basic"
                                form={form}
                                style={{
                                    width: "100%",
                                }}
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                autoComplete="off"
                            >
                                {contactForm?.fields?.map((obj, index) => {
                                    return (
                                        <>
                                            {obj.type === "text" ? (

                                                <Form.Item
                                                    key={index}
                                                    name={obj.name}
                                                    rules={[
                                                        {
                                                            required: obj?.required,
                                                            message: `Please input your ${obj?.name}!`,
                                                        },
                                                        {
                                                            validator: (_, value) => {
                                                                if (obj.name === 'phone' && value && value.length < 6) {
                                                                    return Promise.reject('Phone number should be greater than 6 digits');
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        },
                                                    ]}
                                                >
                                                    {obj.name === 'phone' ? (
                                                        <PhoneInput
                                                            country={'in'}
                                                            enableSearch={true}
                                                            // onChange={(phone) => setPhone(phone)}
                                                            inputStyle={{ width: '100%', borderRadius: "20px", height: "41px", backgroundColor: "#f9fafb" }}
                                                            buttonStyle={{ borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px" }}
                                                            // dropdownClass="bg-white border border-gray-200 shadow-lg mt-2 rounded-lg"
                                                            inputClass="w-full px-4 py-2 text-gray-600 placeholder-gray-400 bg-gray-50 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-200"

                                                        />
                                                    ) : (
                                                        <Input
                                                            className=' w-full px-4 py-2 text-gray-600 placeholder-gray-400 bg-gray-50 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-200'
                                                            placeholder={capitalizeFirstLetter(obj.placeholder)}
                                                        />
                                                    )}
                                                </Form.Item>
                                            ) : obj.type === 'radio' ? (

                                                <Form.Item
                                                    key={index}
                                                    name={obj.name}
                                                    rules={[
                                                        {
                                                            required: obj?.required,
                                                            message: `Please select your ${obj?.name}!`,
                                                        },
                                                    ]}
                                                >
                                                    <Radio.Group
                                                    // defaultValue={obj.options[0].value}
                                                    >
                                                        {obj.options?.map((option, idx) => (
                                                            <Radio key={idx} value={option.value} style={{ color: txtColor }} >
                                                                {option.label}
                                                            </Radio>
                                                        ))}
                                                    </Radio.Group>
                                                </Form.Item>
                                            ) : obj.type === 'textarea' ? (
                                                <Form.Item
                                                    key={index}
                                                    name={obj.name}
                                                    rules={[
                                                        {
                                                            required: obj?.required,
                                                            message: `Please input your ${obj?.name}!`,
                                                        },
                                                    ]}
                                                >
                                                    <TextArea placeholder={capitalizeFirstLetter(obj.placeholder)} rows={4} className='w-full px-4 py-2 text-gray-600 placeholder-gray-400 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-200' />
                                                </Form.Item>
                                            ) :
                                                ""

                                            }
                                        </>
                                    )
                                })}

                                <Form.Item
                                    className='flex justify-center mt-8'
                                >
                                    {contactForm?.fields?.length === 0 ? ""
                                        :
                                        <Button loading={loader} type="none" htmlType="submit"
                                            style={{
                                                background: btnColor,
                                                color: btnTxtColor
                                            }}
                                        >
                                            {contactForm?.submitButton}
                                        </Button>
                                    }
                                </Form.Item>
                            </Form>

                        </>
                    }
                    {activeTab === "tab2" &&
                        <>
                            {informations?.contents?.map((item) => (
                                <div>
                                    {item?.heading &&
                                        <p class="font-semibold text-base  text-center mt-4 mb-5" id="c-LocalAddress">
                                            {item?.heading}
                                        </p>
                                    }
                                    <p className="mb-2 text-sm "><strong>{item.tittle}:</strong> {item?.value}</p>
                                </div>
                            ))}
                        </>
                    }
                </div>
            </div >
            {contextHolder}
        </div >
    )
}

export default Contact